import type { OnInit } from '@angular/core';
import { Directive, inject, input } from '@angular/core';

import { Analytics, ANALYTICS_VIEW_CONTEXT } from '@core/analytics-types';
import { I18nService } from '@core/i18n-legacy';

import type { HelpTranslationLinkMapKey } from './types';
import { HelpTranslationLinkMap } from './types';

@Directive({
  standalone: true,
  selector: '[rtHelpArticle]',
  host: {
    '[attr.href]': 'href',
    '[attr.target]': '"_blank"',
    '(click)': 'onClick()',
  },
})
export class HelpArticlesDirective implements OnInit {
  private readonly i18nService = inject(I18nService);
  private readonly analytics = inject(Analytics);
  private readonly viewContext = inject(ANALYTICS_VIEW_CONTEXT, { optional: true });

  private readonly namespace = 'HelpArticleLinkClick';

  public readonly rtHelpArticle = input<HelpTranslationLinkMapKey>(undefined!);

  public href: string;

  public ngOnInit(): void {
    this.href = this.resolveHelpArticleURL();
  }

  public onClick(): void {
    if (!this.href) return;

    const eventProps = {
      url: this.href,
      key: this.rtHelpArticle(),
      ...(this.viewContext?.length ? { viewContext: this.viewContext } : {}),
    };

    this.analytics.track(this.namespace, eventProps);
  }

  private resolveHelpArticleURL(): string {
    const rtHelpArticle = this.rtHelpArticle();
    if (!rtHelpArticle || !HelpTranslationLinkMap[rtHelpArticle])
      throw new Error('Invalid help article key identifier');

    return this.i18nService.translate(HelpTranslationLinkMap[rtHelpArticle]);
  }
}
